import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=61c2f9a0&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=61c2f9a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2f9a0",
  null
  
)

export default component.exports